/*** IMPORTS FROM imports-loader ***/
var $ = window.jQuery;

// removed by extract-text-webpack-plugin



//////////////////
// WEBPACK FOOTER
// ./node_modules/imports-loader?$=>window.jQuery!./src/wp-migrate-db-pro/asset/src/sass/plugin-update-styles.scss
// module id = 133
// module chunks = 0